import { render, staticRenderFns } from "./BNumberField.vue?vue&type=template&id=e36c1774&"
import script from "./BNumberField.vue?vue&type=script&lang=js&"
export * from "./BNumberField.vue?vue&type=script&lang=js&"
import style0 from "./BNumberField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports